import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';
import { SpinnerComponent } from '../spinner/spinner.component';

export interface AdoProcessingDialogData {
    title?: string;
    message?: string;
}

@Component({
    selector: 'app-ado-processing-dialog',
    templateUrl: './ado-processing-dialog.component.html',
    styleUrls: ['./ado-processing-dialog.component.css'],
    imports: [MaterialModule, SpinnerComponent]
})
export class AdoProcessingDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: AdoProcessingDialogData) { }
}
